import React from "react";
import { Link, withRouter, RouteComponentProps } from "react-router-dom";
import { routes } from "../../../routes";
import JF_LOGO_NEW from "../../../../assets/images/JF Color Logomark.png";
import userService from "../../../../services/userService";
import { connect } from "react-redux";
import { Dispatch } from "redux";

interface ISidebarProps extends RouteComponentProps {
  logout: () => void;
}

const DeveloperPortalSidebar: React.FC<ISidebarProps> = (props) => {
  const { location } = props;

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = () => {
    props.logout();
  };

  return (
    <aside className="portal-sidebar">
      <div className="sidebar-header">
        <Link to={routes.DEVELOPER_PORTAL_DASHBOARD} className="d-flex align-items-center" style={{ textDecoration: 'none' }}>
          <img src={JF_LOGO_NEW} alt="Journey Foods" style={{ height: '32px', width: 'auto' }} />
          <span style={{ 
            color: '#ffffff', 
            fontSize: '18px', 
            fontWeight: 700, 
            marginLeft: '12px',
            letterSpacing: '-0.02em',
            fontFamily: '"Inter", sans-serif'
          }}>JourneyFoods</span>
        </Link>
      </div>

      <div className="search-docs">
        <div className="search-wrapper">
          <i className="fa fa-search"></i>
          <input type="text" placeholder="Search docs..." />
        </div>
      </div>

      <nav className="nav-section">
        <div className="nav-group">
          <Link to="#" className="nav-item">
            <i className="fa fa-home"></i>
            <span>Getting Started</span>
            <i className="fa fa-chevron-right chevron"></i>
          </Link>
        </div>

        <div className="nav-group">
          <Link to="#" className="nav-item active">
            <i className="fa fa-lock"></i>
            <span>Authentication</span>
            <i className="fa fa-chevron-down chevron"></i>
          </Link>
          <div className="sub-nav">
            <Link to={routes.DEVELOPER_PORTAL_API_KEYS} className="sub-item active">API Keys</Link>
            <Link to="#" className="sub-item">OAuth 2.0</Link>
            <Link to="#" className="sub-item">Rate Limits</Link>
            <Link to="#" className="sub-item">Scopes & Permissions</Link>
          </div>
        </div>

        <div className="nav-group">
          <Link to="#" className="nav-item">
            <i className="fa fa-database"></i>
            <span>Ingredient Database</span>
            <span className="badge">2B+</span>
            <i className="fa fa-chevron-right chevron"></i>
          </Link>
        </div>

        <div className="nav-group">
          <Link to="#" className="nav-item">
            <i className="fa fa-flask"></i>
            <span>Formulation API</span>
            <i className="fa fa-chevron-right chevron"></i>
          </Link>
        </div>

        <div className="nav-group">
          <Link to="#" className="nav-item">
            <i className="fa fa-shopping-cart"></i>
            <span>Marketplace</span>
            <span className="badge" style={{ background: 'rgba(23, 201, 220, 0.2)', color: '#17C9DC' }}>NEW</span>
            <i className="fa fa-chevron-right chevron"></i>
          </Link>
        </div>

        <div style={{ marginTop: '40px' }}></div>

        <div className="nav-group">
          <Link to="#" className="nav-item">
            <i className="fa fa-book"></i>
            <span>API Reference</span>
          </Link>
          <Link to="#" className="nav-item">
            <i className="fa fa-history"></i>
            <span>Changelog</span>
          </Link>
          <Link to={routes.DEVELOPER_PORTAL_SETTINGS} className="nav-item">
            <i className="fa fa-cog"></i>
            <span>Settings</span>
          </Link>
          <Link to="#" className="nav-item">
            <i className="fa fa-question-circle"></i>
            <span>Support</span>
          </Link>
        </div>
        
        <div style={{ marginTop: 'auto', paddingBottom: '20px' }}>
          <div className="nav-group" style={{ 
            marginTop: '40px', 
            paddingTop: '20px', 
            borderTop: '1px solid rgba(255, 255, 255, 0.1)' 
          }}>
            <Link to={routes.DASHBOARD} className="nav-item" style={{ marginBottom: '12px' }}>
              <i className="fa fa-arrow-left"></i>
              <span>Back to Main App</span>
            </Link>
            <div 
              className="nav-item" 
              onClick={handleLogout} 
              style={{ cursor: 'pointer', color: '#ef4444' }}
            >
              <i className="fa fa-sign-out"></i>
              <span>Logout</span>
            </div>
          </div>
        </div>
      </nav>

      <div className="sidebar-footer">
        <div className="version">API v3.2.1 <span style={{ color: '#10b981' }}>stable</span></div>
      </div>
    </aside>
  );
};

const mapDispatchToProps = {
  logout: userService.logout
};

export default connect(null, mapDispatchToProps)(withRouter(DeveloperPortalSidebar));
